export const CUSTOMERS = 'CUSTOMERS';
